export default {
    fields: {
        address: {
            label: 'Adresa',
            placeholder: 'Unesite adresu',
        },
        city: {
            label: 'Grad',
            placeholder: 'Odaberite grad',
        },
        country: {
            label: 'Država',
            placeholder: 'Odaberite državu',
        },
        phone: {
            label: 'Telefon',
            placeholder: '+3811231231',
        },
        email: {
            label: 'Email',
            placeholder: "kompanija{'@'}mojemail.com",
        },
        type: {
            label: 'Tip',
            placeholder: 'Odaberite tip',
        },
    },
    business: 'Filijala',
    parking: 'Parking',
}
